export function isOptionActive (option, activeOption) {
    const optionName = typeof activeOption === 'function' ? activeOption() : activeOption;

    return option === optionName;
}
